<div id="bookmark-know-overlay" class="bottom-center-overlay bgc-glass" [ngStyle]="overlayStyles">
  <p class="larger-font">
    <ng-container *ngTemplateOutlet="bookmarkMessage"></ng-container>
  </p>
</div>

<ng-template #bookmarkOrchestratorsLink>
  <a
    class="overlay-link larger-font"
    (click)="onLinkClick()"
    href="https://orchestrators.genesys.com"
    target="_blank"
    title="Genesys Orchestrators Link"
    >Genesys Orchestrators</a
  >
</ng-template>

<ng-template #bookmarkMessage>
  Be sure to bookmark <ng-container *ngTemplateOutlet="bookmarkOrchestratorsLink"></ng-container> -- Everything you need
  in one place to succeed.
</ng-template>
